/* Components */
//todo

// const data = [
//   {
//     title: "test",
//     date: "",
//     image: "",
//     description: "",
//     detailUrl: "",
//   },
// ];

function News() {
  return (
    <>
      <div className="content_container">News here</div>
    </>
  );
}

export default News;
